<template>
	<div class="cars-filters">
		<Transition name="fade" mode="out-in">
			<div v-if="showCurrentFilters" class="cars-filters__selected">
				<CarsFiltersSingleFilterSelected isDeleteAll :filtersData />
				<CarsFiltersSingleFilterSelected
					v-if="carsStore.getCurrentGroups && carsStore.getCurrentGroups.length >= 1"
					:groups="carsStore.getCurrentGroups"
					:filtersData />
				<CarsFiltersSingleFilterSelected v-if="carsStore.getCurrentPriceRange" :priceRange="carsStore.getCurrentPriceRange" :filtersData />
				<CarsFiltersSingleFilterSelected v-for="(filter, i) in carsStore.getCurrentFilters" :key="i" :filter="filter" :filtersData />
			</div>
		</Transition>
		<Transition name="fade" mode="out-in">
			<div v-if="showCurrentFilters" class="cars-filters__divider-container">
				<div class="cars-filters__divider"></div>
			</div>
		</Transition>
		<div class="cars-filters__select cars-filters__select--mobile">
			<CarsFiltersSingleFilter v-for="(filter, i) in mobileFiltersData" :key="i" :filter="filter" />
		</div>
		<div class="cars-filters__select cars-filters__select--web">
			<CarsFiltersSingleFilter v-for="(filter, i) in filtersData" :key="i" :filter="filter" />
		</div>
	</div>
</template>

<script setup lang="ts">
import type { ISingleFilterProps } from './SingleFilter/SingleFilter.vue'

const carsStore = useCarsStore()
const showCurrentFilters = computed(
	() =>
		(carsStore.getCurrentFilters && carsStore.getCurrentFilters?.length >= 1) ||
		(carsStore.getCurrentGroups && carsStore.getCurrentGroups?.length >= 1) ||
		carsStore.getCurrentPriceRange,
)

const filtersData: ISingleFilterProps[] = [
	{
		title: 'vehicle_category',
		filterName: EFilterNames.GROUP,
	},
	// {
	// 	title: 'price_per_day',
	// 	items: [
	// 		{ name: '0 zł - 100 zł', value: '0-100' },
	// 		{ name: '101 zł - 200 zł', value: '100-200' },
	// 		{ name: '201 zł - 300 zł', value: '200-300' },
	// 		{ name: '301 zł +', value: '300+' },
	// 	],
	// 	filterName: EFilterNames.PRICE,
	// 	// disabled: true,
	// },

	{
		title: 'transmission',
		filterName: EFilterNames.TRANSMISSION,
		items: [
			{ name: 'automatic', value: 'automatic' },
			{ name: 'manual', value: 'manual' },
		],
	},
	{
		title: 'number_of_seats',
		isSeats: true,
		filterName: EFilterNames.SEATS,
	},
	{
		title: 'engine',
		filterName: EFilterNames.FUEL_TYPE,
	},
	{
		title: 'sort',
		filterName: EFilterNames.SORT,
		items: [
			{ name: 'most_popular', value: ESortValues.MOST_POPULAR },
			{ name: 'price_asc', value: ESortValues.PRICE_ASC },
			{ name: 'price_desc', value: ESortValues.PRICE_DESC },
		],
		isSort: true,
	},
]

const mobileFiltersData: ISingleFilterProps[] = [
	{
		title: 'filters',
		isAll: true,
	},
	{
		title: 'sort',
		isSort: true,
		items: [
			{ name: 'most_popular', value: ESortValues.MOST_POPULAR },
			{ name: 'price_asc', value: ESortValues.PRICE_ASC },
			{ name: 'price_desc', value: ESortValues.PRICE_DESC },
		],
		filterName: EFilterNames.SORT,
	},
]
</script>

<style lang="scss">
@import './Filters';
</style>
